import React from "react";
import { Redirect } from "react-router-dom";

/**
 * RD 95133: a listagem de usuários passou a ser a aba "Usuários" do menu
 * "Cadastros" (src/pages/Cadastros/ListaUsuarios.js). Esta rota continua
 * existindo só para não quebrar links antigos para /usuario.
 */
export default function Participante() {
  return <Redirect to="/cadastros" />;
}
